// Module
var code = `<div class="modal-dialog modal-lg virtualBulkInsertDetails" role="document">
    <div class="modal-content" tabindex="-1">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <div>
                <h3 class="modal-title text-success" id="myModalLabel">Bulk inserts - inserted items</h3>
                <div class="notification-time" data-bind="text: bulkInserts.displayDate().format('LLL')"></div>
            </div>
        </div>
        <div class="modal-body">
            <div class="margin-bottom" style="position: relative; height: 300px">
                <virtual-grid style="height: 300px" class="resizable flex-window" params="controller: gridController"></virtual-grid>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bind="click: close">
                <i class="icon-cancel"></i><span>Close</span>
            </button>
        </div>
    </div>
</div>

<div class="tooltip json-preview js-virtual-bulk-insert-details-tooltip" style="opacity: 0">
</div>
`;
// Exports
export default code;